var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.312,
    height: 19.312,
    viewBox: "0 0 19.312 19.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M0,0H19.312V19.312H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M15.679,7.023h-.8V3H5.219V7.023h-.8A2.411,2.411,0,0,0,2,9.437v4.828H5.219v3.219h9.656V14.265h3.219V9.437A2.411,2.411,0,0,0,15.679,7.023ZM6.828,4.609h6.437V7.023H6.828Zm6.437,9.656v1.609H6.828V12.656h6.437Zm1.609-1.609V11.047H5.219v1.609H3.609V9.437a.807.807,0,0,1,.8-.8H15.679a.807.807,0,0,1,.8.8v3.219Z",
    transform: "translate(-0.391 -0.586)",
    fill: "#4eb6ee"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_743",
    "data-name": "Ellipse 743",
    cx: 0.805,
    cy: 0.805,
    r: 0.805,
    transform: "translate(13.679 8.449)",
    fill: "#4eb6ee"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.18f0c1dbbe8de243322d27cbebbe5ff0.svg";
export { ForwardRef as ReactComponent };